export default __webpack_public_path__ + "static/media/quote.fd6bd5ef.png";